// Private lesson setup status for a coach, shared by the admin coach cards on
// the private lessons dashboard and the sidebar panel on a coach's own
// dashboard so both read the same way.
import { plainTextFromTrix } from '../../trix_text';

export const coachSetupStatusMix = {
  methods: {
    initials(coach) {
      return `${(coach.first_name || ' ')[0] || ''}${(coach.last_name || ' ')[0] || ''}`.trim();
    },
    hasPhoto(coach) {
      return Boolean(coach.avatar);
    },
    hasBio(coach) {
      return plainTextFromTrix(`${coach.plain_bio || ''} ${coach.bio || ''}`).length > 0;
    },
    hasPricing(coach) {
      return (coach.product_coach_listings || []).length > 0;
    },
    // Pricing plus accepting lessons is all it takes for families to book. A
    // photo and bio are optional, so a coach can be bookable without being
    // finished — that middle state gets its own badge rather than claiming
    // setup is complete at 50% progress.
    isBookable(coach) {
      return coach.accepting_private_lessons && this.hasPricing(coach);
    },
    isFullySetUp(coach) {
      return this.isBookable(coach) && this.hasPhoto(coach) && this.hasBio(coach);
    },
    setupStatus(coach) {
      if (this.isFullySetUp(coach)) {
        return { cssClass: 'is-ready', label: 'Setup complete', title: '' };
      }
      if (this.isBookable(coach)) {
        return {
          cssClass: 'is-partial',
          label: 'Bookable',
          title: 'Families can book this coach, but a photo and bio help them choose.',
        };
      }
      return {
        cssClass: 'is-setup',
        label: 'Setup needed',
        title: 'Pricing and accepting private lessons are required before families can book.',
      };
    },
    progressPercent(coach) {
      const steps = [
        this.hasPhoto(coach),
        this.hasBio(coach),
        this.hasPricing(coach),
        coach.accepting_private_lessons,
      ];
      return (steps.filter(Boolean).length / steps.length) * 100;
    },
    pricingText(coach) {
      if (!this.hasPricing(coach)) {
        return 'No pricing assigned';
      }
      const names = coach.product_coach_listings.map((listing) => listing.product.name);
      return `Pricing: ${names.join(', ')}`;
    },
  },
};
